module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-sm-6': _vm.question.image,
        'col-sm-12': !_vm.question.image
    }
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.question.num ? _vm.question.num + '. ' : '') + "\n      "), (_vm.question.audio && _vm.canAudioReplay) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.$parent.play(_vm.question.audio)
      },
      "mouseover": function($event) {
        _vm.speakerHover = true
      },
      "mouseout": function($event) {
        _vm.speakerHover = false
      }
    }
  }, [(!_vm.speakerHover) ? _c('img', {
    staticClass: "clickable",
    attrs: {
      "src": require("../../assets/images/btn_play_sound_off.png")
    }
  }) : _c('img', {
    staticClass: "clickable",
    attrs: {
      "src": require("../../assets/images/btn_play_sound_on.png")
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.question.image) ? _c('p', [_c('img', {
    attrs: {
      "src": _vm.question.image,
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.question.title) ? _c('p', {
    staticClass: "pre",
    domProps: {
      "innerHTML": _vm._s(_vm.question.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question.descritpion) ? _c('p', {
    staticClass: "pre",
    domProps: {
      "innerHTML": _vm._s(_vm.question.descritpion)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'col-sm-6': _vm.question.image, 'col-sm-12': !_vm.question.image
    }
  }, [_c('Options', {
    attrs: {
      "items": _vm.question.items,
      "selected": _vm.selected.answers
    },
    on: {
      "answer": _vm.handleAnswer
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-051340af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/modules/MultiChoice.vue
// module id = 702
// module chunks = 1